import { create } from "zustand";
import { View } from "../components/orderhistory/types";
import { startOfPeriod } from "../utils/dateUtils";
import { calculateEndDate } from "../utils/dateUtils";

interface TimeIntervalState {
  // Old approach - keep for backward compatibility (will be removed after migration)
  view: View;
  cursor: Date;
  customStartDate: Date | null;
  customEndDate: Date | null;
  setView: (view: View) => void;
  setCursor: (cursor: Date) => void;
  setCustomStartDate: (date: Date | null) => void;
  setCustomEndDate: (date: Date | null) => void;

  // New approach - explicit date range for simpler filtering
  startDate: Date;
  endDate: Date;
  setStartDate: (date: Date) => void;
  setEndDate: (date: Date) => void;
  setDateRange: (start: Date, end: Date) => void;
}

const initialStartDate = startOfPeriod(new Date(), 'week');
const initialEndDate = calculateEndDate(initialStartDate, 'week');

export const useTimeIntervalStore = create<TimeIntervalState>((set, get) => ({
  // Old approach
  view: 'week',
  cursor: initialStartDate,
  customStartDate: null,
  customEndDate: null,

  // New approach
  startDate: initialStartDate,
  endDate: initialEndDate,

  // Old setters (with sync to new approach)
  setView: (view) => {
    const newCursor = startOfPeriod(new Date(), view);
    const newEnd = calculateEndDate(newCursor, view);
    set({
      view,
      cursor: newCursor,
      startDate: newCursor, // Sync to new
      endDate: newEnd,      // Sync to new
    });
  },
  setCursor: (cursor) => {
    // You'd need logic here to infer view from cursor if desired, but keeping it simple
    set({
      cursor,
      startDate: cursor,    // Sync to new (assuming cursor is start)
      // Optionally sync endDate based on view
    });
  },
  setCustomStartDate: (customStartDate) => set({ customStartDate }),
  setCustomEndDate: (customEndDate) => set({ customEndDate }),

  // New setters (with sync to old approach if custom dates are not set)
  setStartDate: (date) => {
    const state = get();
    if (!state.customStartDate) {
      set({ startDate: date });
      // Optionally sync cursor if not using custom
      if (state.cursor.getTime() === state.startDate.getTime()) {
        set({ cursor: date });
      }
    }
  },
  setEndDate: (date) => {
    const state = get();
    if (!state.customEndDate) {
      set({ endDate: date });
      // Sync logic similar to above if needed
    }
  },
  setDateRange: (start, end) => {
    const state = get();
    if (!state.customStartDate && !state.customEndDate) {
      set({
        startDate: start,
        endDate: end,
        // Sync to old if not custom
        cursor: start,
      });
    }
  },
}));